// For each city, this is a map of the possible airports and their distances to the city center.
export const cityAirportsDistance: Record<string, Record<string, number>> = {
  AMS: {
    AMS: 2,
    RTM: 64,
  },
  BCN: {
    BCN: 12,
    GRO: 82,
    REU: 92,
  },
  BFS: {
    BHD: 4,
    BFS: 20,
  },
  BRU: {
    BRU: 11,
    CRL: 49,
  },
  BTS: {
    BTS: 10,
    VIE: 27,
  },
  CDT: {
    CDT: 27,
    VLC: 66,
  },
  CGN: {
    CGN: 15,
    DUS: 41,
    DTM: 73,
    NRN: 93,
  },
  CIY: {
    CIY: 5,
    CTA: 71,
  },
  CTA: {
    CTA: 5,
    CIY: 71,
  },
  DTM: {
    DTM: 1,
    CGN: 75,
  },
  DUS: {
    DUS: 7,
    CGN: 47,
    DTM: 58,
    NRN: 61,
  },
  EDI: {
    EDI: 10,
    GLA: 67,
  },
  FLR: {
    FLR: 6,
    PSA: 69,
  },
  FRA: {
    FRA: 12,
    HHN: 103,
  },
  FRL: {
    FRL: 3,
    BLQ: 68,
  },
  GLA: {
    GLA: 2,
    PIK: 46,
  },
  GNB: {
    GNB: 37,
    LYS: 86,
  },
  HAM: {
    HAM: 9,
    LBC: 55,
  },
  IAS: {
    IAS: 3,
    BCM: 82,
    RMO: 107,
  },
  IST: {
    SAW: 30,
    IST: 34,
  },
  KRK: {
    KRK: 16,
    KTW: 77,
  },
  KTW: {
    KTW: 25,
    KRK: 69,
  },
  KUN: {
    KUN: 0,
    VNO: 93,
  },
  LON: {
    LCY: 12,
    LHR: 23,
    LGW: 40,
    STN: 49,
    LTN: 43,
    SEN: 57,
  },
  LYS: {
    LYS: 9,
    GNB: 59,
  },
  MIL: {
    LIN: 8,
    MXP: 39,
    BGY: 46,
    PMF: 117,
  },
  OSL: {
    OSL: 37,
    TRF: 85,
  },
  PAR: {
    ORY: 15,
    CDG: 23,
    BVA: 68,
    XCR: 136,
  },
  PMF: {
    PMF: 1,
    LIN: 108,
    BGY: 108,
    MXP: 157,
  },
  ROM: {
    CIA: 15,
    FCO: 23,
  },
  RTM: {
    RTM: 16,
    AMS: 55,
  },
  STO: {
    BMA: 7,
    ARN: 37,
    VST: 86,
    NYO: 90,
  },
  SUF: {
    SUF: 10,
    CRV: 66,
  },
  TCI: {
    TFS: 27,
    TFN: 28,
  },
  TRN: {
    TRN: 15,
    CUF: 60,
  },
  VCE: {
    VCE: 5,
    TSF: 32,
  },
  VIE: {
    VIE: 14,
    BTS: 63,
  },
  VLC: {
    VLC: 8,
    CDT: 91,
  },
  VNO: {
    VNO: 7,
    KUN: 90,
  },
  WAW: {
    WAW: 8,
    WMI: 35,
    RDO: 94,
  },
};
